import { styled, Typography, WithTheme } from '@material-ui/core'
import { Variant } from 'shared/types'

const SUCCESS_COLOR = '#45B89C'
const ICON_SIZE = 25

interface WrapperProps extends WithTheme {
  variant: Variant
}

export const Text = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1.2),
  whiteSpace: 'nowrap',
}))

export const Wrapper = styled('div')(({ theme, variant }: WrapperProps) => ({
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'flex-start',
  margin: theme.spacing(1, 0, 1.2),
  '& svg': {
    width: ICON_SIZE,
    height: ICON_SIZE,
  },
  '& *': {
    fontSize: 16,
    fontWeight: 600,
    overflow: 'visible',
    color: variant === Variant.Error ? theme.palette.error.main : SUCCESS_COLOR,
  },
}))
